import { Component } from '@angular/core';

@Component({
    selector: 'app-verifying-session',
    standalone: true,
    imports: [],
    templateUrl: './verifying-session.component.html',
    styleUrl: './verifying-session.component.scss',
})
export class VerifyingSessionComponent {}
